import { TAppState } from '../../types/appState';
import { IOffersSelector } from '../../types/offersForSelection';

export function offersForSelection(state: TAppState): IOffersSelector {
  return state.offersForSelection;
}
